import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: "快速导航",
      links: [
        { label: "首页", href: "/" },
        { label: "分类浏览", href: "/category/all" },
        { label: "关于我们", href: "/about" },
      ],
    },
    {
      title: "热门分类",
      links: [
        { label: "恋爱漫画", href: "/category/romance" },
        { label: "奇幻漫画", href: "/category/fantasy" },
        { label: "动作漫画", href: "/category/action" },
        { label: "校园漫画", href: "/category/school" },
      ],
    },
    {
      title: "关于我们",
      links: [
        { label: "品牌介绍", href: "/about" },
        { label: "联系方式", href: "/about#contact" },
      ],
    },
  ];

  return (
    <footer className="bg-background-800" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                韩漫漫画网
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              无遮韩国免费漫画大全，提供流畅的免费在线阅读韩漫体验，是漫画爱好者聚集的理想之地。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">
                {section.title}
              </h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-primary-300 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {currentYear} 韩漫漫画网 - 无遮韩国免费漫画大全 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-background-400 hover:text-background-200 transition-colors duration-200"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-background-400 hover:text-background-200 transition-colors duration-200"
              rel="nofollow"
            >
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}